import { CheckMark } from '../components/Icons';
import { useAlert } from '../components/Alert';
import type { CitizenSubmitResult } from '../api/contract';

/**
 * 提交结果面板。
 *
 * ★★ 口径与手机端 T5 完全一致（`src/pages/Success.tsx` 文件头有完整来由）：
 *    **只留两样东西 —— 投诉编号，和「成都房经协会联系您」**。
 *    （2026-09-03 协会令：来电主体由「工作人员」改成「成都房经协」，与手机端同步改，
 *      "只留两样东西"这条口径不变。）
 *    不显示 `处理状态`／`提交时间`／`还需补充` —— 那三样是给内部看的：
 *      · 「处理状态＝待处理」是乐享那张表的字段值，市民按完提交本来就知道还没处理；
 *      · 「提交时间」在「我的投诉」里每条都有；
 *      · 「还需补充」列的是我们自己没抽出来的要素，把内部工序的焦虑转嫁给市民。
 *    也不放「协会受理 → 核查处理 → 办结反馈」那种流程条：那是在解释系统怎么运转。
 *
 * ★ 查进度不在这一页做（PC 端本期只做提交），如实引导到手机端，
 *   **不放一个点了没反应的「查询进度」按钮**。
 */
export default function PcSuccess({
  result,
  onAgain,
}: {
  result: CitizenSubmitResult;
  onAgain: () => void;
}) {
  const alert = useAlert();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(result.billNo);
      alert({ title: '投诉编号已复制', tone: 'plain' });
    } catch {
      // 浏览器不给复制权限是常事，如实说，并给出人能做到的替代动作
      alert({ title: '没能自动复制', text: '请手动选中上面的编号后按 Ctrl+C 复制。' });
    }
  };

  return (
    <section className="pcdone">
      <span className="pcdone-ring">
        <span className="pcdone-ok">
          <CheckMark size={34} width={4} />
        </span>
      </span>

      <h1>投诉提交成功</h1>

      <div className="pcdone-no">
        <span className="pcdone-no-k">投诉编号</span>
        <b className="pcdone-no-v">{result.billNo}</b>
        <button type="button" className="pcbtn pcbtn-ghost pcbtn-sm" onClick={() => void copy()}>
          复制
        </button>
      </div>

      {/* ★ 2026-09-03 协会令：来电主体「工作人员」→「成都房经协」，与手机端 T5 逐字一致 */}
      <p className="pcdone-say">成都房经协在核实后会与您电话联系，请保持手机畅通。</p>
      <p className="pcdone-sub">办理进度可在手机上打开房诉通，在「我的投诉」中查看。</p>

      <button type="button" className="pcbtn pcbtn-line" onClick={onAgain}>
        再提交一件投诉
      </button>
    </section>
  );
}
